export default "__VITE_ASSET__dqzxKhVT__"